import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import markSelectOptions from './markSelectOptions'

const OPTION_IDS = 'option_ids'

const MultiSelectMarkField = ({ mark, readonly, onChange }) => {
  const options = markSelectOptions(mark.question.options)
  const value = options.filter(option => (mark[OPTION_IDS] || []).includes(option.value))

  const handleChange = useCallback(selected => {
    onChange({ [OPTION_IDS]: (selected || []).map(option => option.value) })
  }, [onChange])

  return (
    <Select
      className="tw:lg:w-1/2"
      closeMenuOnSelect={false}
      error={false}
      isClearable={!mark.question.mandatory}
      isDisabled={readonly}
      options={options}
      value={value}
      isMulti
      onChange={handleChange}
    />
  )
}

MultiSelectMarkField.propTypes = {
  mark: PropTypes.shape({
    [OPTION_IDS]: PropTypes.arrayOf(PropTypes.number),
    question: PropTypes.shape({
      mandatory: PropTypes.bool,
      options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        content: PropTypes.string,
        discarded: PropTypes.bool
      }))
    })
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool
}

MultiSelectMarkField.defaultProps = {
  readonly: false
}

export default MultiSelectMarkField
